import { createEmbedMessageHandler } from './embedMessageHandler';
const getProductDataShopifyDirect = async (url) => {
    console.log('[getProductDataShopifyDirect] Fetching product data for:', url);
    const result = await fetch(`${url}.js`, {
        credentials: 'same-origin',
    });
    const jsonData = await result.json();
    return jsonData;
};
export const getProductDataEmbed = async (url, timeout = 10000) => {
    // console.log('[getProductDataEmbed] Fetching product data for:', url);
    const handle = url.split('/').pop();
    const response = await createEmbedMessageHandler({
        type: 'commerce.getProductData',
        payload: { locator: { type: 'handle', value: handle } },
        timeout,
    });
    return response.data;
};
const useEmbed = true;
// Map to store promises for product data requests
const productDataPromiseCache = new Map();
const getProductData = (url) => {
    // console.log('[getProductData] Fetching product data for:', { url, useEmbed });
    // Check if we already have a promise for this URL
    if (productDataPromiseCache.has(url)) {
        // console.log('[getProductData] Returning cached promise for:', url);
        return productDataPromiseCache.get(url);
    }
    // Create new promise and cache it
    const promise = useEmbed ? getProductDataEmbed(url) : getProductDataShopifyDirect(url);
    productDataPromiseCache.set(url, promise);
    return promise;
};
export default getProductData;
//# sourceMappingURL=getProductData.js.map